import { getApiConfig } from '@foundation/apis/ApiConfig';

import { handleApiResponse } from './helpers/handleApiResponse';

type DeletePaymentInstrumentOptions = {
  readonly instrumentId: string;
  readonly bearerToken: string;
};

export async function deletePaymentInstrument(
  options: DeletePaymentInstrumentOptions,
): Promise<void> {
  const { paymentsApiUrl } = getApiConfig();
  const { instrumentId, bearerToken } = options;

  const response = await fetch(
    `${paymentsApiUrl}/paymentdata/${instrumentId}`,
    {
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${bearerToken}`,
      },
    },
  );

  return handleApiResponse<void>(
    response,
    'Failed to delete payment instrument',
  );
}
